import { Footer } from "./components/footer";
import { Header } from "./components/header";
import { About } from "./pages/about";
import { Contact } from "./pages/contact";
import { Home } from "./pages/home";
import { Portfolio } from "./pages/portfolio";
import { Testimony } from "./pages/testimony";

export function App() {
  return (
    <>
      <div id="top" />
      <Header />
      <Home />
      <About />
      <Testimony />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  );
}
